import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Organisation from "./Organisation";

@Model()
class InsightsQualitativeTopic extends ApplicationRecord {
  static jsonapiType = "insights_qualitative_topics";

  @Attr() archivedAt: string;

  @Attr() globalEntityGroupId: number;

  @Attr() name: string;

  @BelongsTo() organisation: Organisation;

  @Attr() organisationId: string;

  @Attr() subTopics: string[];

  @Attr() topicType: string;
}

export default InsightsQualitativeTopic;
